"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
const vue_property_decorator_1 = require("vue-property-decorator");
const MapOl_vue_1 = __importDefault(require("../../Results/MapOlLocal/Components/MapOl.vue"));
const MetricCard_vue_1 = __importDefault(require("./MetricCard.vue"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const RedirectionService_1 = __importDefault(require("../class/services/RedirectionService"));
const Controller_1 = __importDefault(require("@becrop/components/Map/Controller"));
const MapLayer_1 = __importDefault(require("@becrop/components/MapBmk/models/MapLayer"));
const EventTracker_1 = __importDefault(require("@becrop/abstract/Utils/EventTracker"));
const PreQuoteModal_vue_1 = __importDefault(require("@becrop/components/ClientFarmListView/components/PreQuoteModal.vue"));
const eBeCropIcon_vue_1 = __importDefault(require("@becrop/components/DashboardSingle/components/StatusTags/eBeCropIcon.vue"));
const MapZone_1 = __importDefault(require("@becrop/components/Map/models/MapZone"));
let PreviewFarms = class PreviewFarms extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.redirectionService = new RedirectionService_1.default();
        this.eventTracker = new EventTracker_1.default();
        this.isPreQuoteModalActive = false;
        this.loadingGenerative = false;
        // *********** NEW MAP CONFIG ***************
        this.mapLayer = new MapLayer_1.default({
            provider: this.vuedataSet.map_config.provider,
            key: this.vuedataSet.map_config.apikey,
        });
        this.MAP_CONTROLLER = new Controller_1.default();
        // *********** NEW MAP CONFIG ***************
    }
    eventTrackerListener(eventName, eventValues) {
        this.eventTracker.trackEvent(eventName, eventValues);
    }
    deployPreQuoteModal() {
        this.isPreQuoteModalActive = true;
    }
    dismissPreQuoteModal() {
        this.isPreQuoteModalActive = false;
    }
    viewResult() {
        /*         this.redirectionService.open(this.project.previewData.resultUrl);
                this.eventTrackerListener('viewResults', {project: this.project.name, proposalId: this.project.proposal.id}) */
    }
    get vuedataSet() {
        return this.vuedata;
    }
    get quoteClass() {
        return (this.farm.quote_status.code.includes('quote')) ?
            `bmfw-color-bmk_info_-2` :
            `bmfw-color-bmk_primary_saturated`;
    }
    drawFarm() {
        var _a, _b, _c;
        if (this.farm && this.farm.geodata) {
            this.MAP_CONTROLLER.zoneBuilder.drawZone(new MapZone_1.default({
                geoData: (_a = this.farm) === null || _a === void 0 ? void 0 : _a.geodata,
                fillColor: `${(_b = this.farm) === null || _b === void 0 ? void 0 : _b.cropColor}50`,
                strokeColor: (_c = this.farm) === null || _c === void 0 ? void 0 : _c.cropColor,
                enableHoverInteraction: false,
                enableSelectInteraction: false,
                zoneName: `${this.farm.id}-${this.farm.name}`,
                centerZone: true,
                avg: 0,
                markers: [],
                preciseResult: false,
                modifyInteraction: false
            }));
        }
    }
    mounted() {
        this.MAP_CONTROLLER.create('map-dashboard', this.vuedataSet.map_config.provider, this.vuedataSet.map_config.apikey, '', '', '', 13, 0, 17);
        this.drawFarm();
    }
    updateMap() {
        this.drawFarm();
    }
    seeLastResult() {
        const url = `/results/map?projectId=${this.farm.last_completed_project.project_id}&areaId=${this.farm.gis_area_id}`;
        window.location.href = url;
    }
    requestQuote() {
        this.deployPreQuoteModal();
    }
    seeGenerative() {
        this.loadingGenerative = true;
        const url = `/last_result?farm_list=true&farm_id=${this.farm.id}`;
        window.location.href = url;
    }
    goToTracking() {
        let url = '/tracking/proposalslist';
        if (this.farm.last_proposal !== null && this.farm.last_proposal.proposal_id !== null) {
            url += `?proposal=${this.farm.last_proposal.proposal_id}`;
        }
        window.location.href = url;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null })
], PreviewFarms.prototype, "farm", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], PreviewFarms.prototype, "vuedata", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('farm', { deep: true })
], PreviewFarms.prototype, "updateMap", null);
PreviewFarms = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { MapOl: MapOl_vue_1.default, MetricCard: MetricCard_vue_1.default, Tag: bmk_ui_framework_1.Tag, ArrowUpRight: lucide_vue_next_1.ArrowUpRight, Button: bmk_ui_framework_1.Button, PreQuoteModal: PreQuoteModal_vue_1.default, eBeCropIcon: eBeCropIcon_vue_1.default },
    })
], PreviewFarms);
exports.default = PreviewFarms;
